import { Container, Row, Col, ListGroup, Button } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import Card from '../components/Card'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
export default function Dashboard(props) {

    const user = useSelector(state => state.user)
    const accounts = useSelector(state => state.accounts)
    const stats = useSelector(state => state.stats)
    const licenseCount = useSelector(state => state.licenseCount)
    const [lastWeek, setLastWeek] = useState()

    const navigate = useNavigate()
    useEffect(() => {
        var today = new Date()
        today.setDate(today.getDate() - 7)
        setLastWeek(today)
        document.title = 'ScamWall | Dashboard'

    }, [])
    return (
        <Container fluid className='pt-4 ps-4 m-0'>

            <h1 className='text-start'>Dashboard</h1>

            <Row >
                <Col md={4} className='mt-4'>
                    <Card>
                        <p ><span className='big-font text-primary'>{licenseCount}</span> <small>/ {user?.licenses} Used</small></p>
                        <p className='lead weight-bold'>Licenses</p>
                        <Button variant='link' className='noDecoration' onClick={() => navigate('/settings')}>Buy More</Button>
                    </Card>
                </Col>
                <Col md={4} className='mt-4'>
                    <Card>
                        <ListGroup>
                            {accounts?.map(user => <ListGroup.Item key={user._id}>{user.fName} {user.lName}</ListGroup.Item>)}

                        </ListGroup>
                        <p className='lead weight-bold mt-4'>Users ({accounts?.length})</p>
                    </Card>
                </Col>
                <Col md={4} className='mt-4'>
                    <Card>
                        <p className='big-font text-primary'>{stats?.chromeDownload}</p>

                        <p className='lead weight-bold mt-4'>Downloads Blocked</p>
                    </Card>
                </Col>

            </Row>
            <Row className='justify-content-center mt-4'>

                <Col md={4}>
                    <Card>
                        <p className='big-font text-primary'>{stats?.chromeTab}</p>

                        <p className='lead weight-bold mt-4'>Harmful Sites Blocked</p>
                    </Card>
                </Col>

                <Col md={4}>
                    <Card>
                        <p className='big-font text-primary'>{stats?.dlInspected}</p>

                        <p className='lead weight-bold mt-4'>Downloads Inspected</p>
                    </Card>
                </Col>
            </Row>


        </Container>
    )
}